import { useAuthStore } from '@/core/store/AuthStore';
const auth = useAuthStore();

const authMapper = {
    userrole: auth.getUserRole,
    mapping: [{ name: 'Data Hub', auth: 0 }]
}

export default authMapper